import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TruncatedGridCell from '../../../../Common/components/TruncatedGridCell';
import { getColumns as getProjectsGridColumns } from '../MyProjectsGrid/getMyProjectsGridColumns';

const packageTypeColumn: GridColDef = {
    field: 'packageName',
    headerName: 'Package type',
    flex: 0.9,
    disableColumnMenu: true,
    renderCell: (params: GridRenderCellParams<string>) => (
        <TruncatedGridCell value={params.value as string} placement='top-start' />
    ),
};

const projectIdColumn: GridColDef = {
    field: 'id',
    headerName: 'Project ID',
    flex: 1.2,
    disableColumnMenu: true,
    sortable: false,
    renderCell: (params: GridRenderCellParams<string>) => (
        <TruncatedGridCell value={params.value as string} placement='top-start' />
    ),
};

export const getColumns = (): GridColDef[] => {
    const byField = new Map(getProjectsGridColumns().map((column) => [column.field, column]));
    const column = (field: string) => byField.get(field) as GridColDef;

    return [
        column('name'),
        projectIdColumn,
        packageTypeColumn,
        column('productOwner'),
        column('costCentre'),
        column('tools'),
        column('status'),
    ];
};
